import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';

function MyVerticallyCenteredModal(props) {
  
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton >
        <Modal.Title id="contained-modal-title-vcenter" >
         {props.heading}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
         <p>{/* check props.body has (http) and display without (http) */}
         {props.body && props.body.includes('http') ? props.body.slice(0, props.body.indexOf('http')-1) : props.body}

          
          {/* check if props.body has (http) then splice (http:// ) and display link*/}
          {props.body && props.body.includes('http') &&
          <a href={props.body.slice(props.body.indexOf('http'))} target="_blank" rel="noreferrer"> {props.body.slice(props.body.indexOf('http'))}</a>
          }</p>
        {props.bullets && 
        <ul className='px-0' style={{listStyle:'none'}}>
          {props.bullets.map((item, index) => (
            <li key={index} >{item}</li>
          ))}
        </ul>
        }
        {/* for stress factors */}
        
        {props.stress && <>
        <b>What they will do: </b>
        <ul>
          {props.action.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <b>💁🏽How to help: </b>
        <ul>
          {props.help.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        </>}
      </Modal.Body>
    </Modal>
  );
}

function PopUpModal(props) {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      {<div onClick={() => setModalShow(true)}>
       {props.item}
      </div>}

      <MyVerticallyCenteredModal
        show={modalShow}
        heading={props.heading}
        body={props.body}
        action={props.action}
        help={props.help}
        onHide={() => setModalShow(false)}
        stress={props.stress}
        bullets={props.bullets}
      />
    </>
  );
}

export default PopUpModal